<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  mounted() {
    
  }
}
</script>
<style lang="scss">
* {
  box-sizing: border-box;
}
html body {
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.mini-toast {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: #333;
  color: white;
  padding: 8px 16px;
  border-radius: 4px;
  z-index: 9999;
  opacity: 1;
  transition: opacity 0.3s;
  font-size: 16px;
}
.mini-toast.fade-out {
  opacity: 0;
}
</style>
